import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import { Formik, FormikHelpers } from 'formik';
import { isNull, isUndefined } from 'lodash';

import { useIsRequired } from '@hooks/yup';
import { Loading, LoadingError } from '@components/Base';
import { selectIsProcessing } from '@components/Auth';
import { InsurancePolicyStatuses } from '@models/InsurancePolicy';

import InsurancePolicyBuyForm, { FormDisabled, FormRequired, FormValues } from '../InsurancePolicyBuyForm';
import { insurancePolicyUpdate, InsurancePolicyUpdatePayload } from '../action';
import { useInsurancePolicyFetch } from '../hook';
import { useInitialValues, useValidationSchema } from './hook';

const InsurancePolicyBuyEditPage = () => {
  const dispatch = useDispatch();
  const isProcessing = useSelector(selectIsProcessing);
  const policy = useInsurancePolicyFetch();
  const initialValues = useInitialValues(policy);
  const validationSchema = useValidationSchema();
  const required = useIsRequired<FormRequired>(validationSchema);

  if (isUndefined(policy)) return <Loading />;
  if (isNull(policy)) return <LoadingError />;
  if (!initialValues) return null;

  const { id, status } = policy;
  const isPending = status === InsurancePolicyStatuses.Pending;
  const canEditBrokerage = isProcessing && isPending;
  const disabled: FormDisabled = {
    brokeragePercentage: !canEditBrokerage,
  };

  const handleSubmit = (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    const payload: InsurancePolicyUpdatePayload = { id, ...values };
    dispatch(insurancePolicyUpdate(payload));
    setSubmitting(false);
  };

  return (
    <Container className="my-3">
      <Row className="gy-5">
        <Col lg={8}>
          <Formik validationSchema={validationSchema} initialValues={initialValues} onSubmit={handleSubmit}>
            <InsurancePolicyBuyForm required={required} disabled={disabled} />
          </Formik>
        </Col>
      </Row>
    </Container>
  );
};

export { InsurancePolicyBuyEditPage };
